import { get, patch, post } from "../../../shared/data";

const mapCategoriesToSelect = (categories) => {
    return categories.map((cat) => {
        return {
            value: cat.code,
            text: cat.description,
        };
    });
};

export const completeShipment = (shipmentKey, codingWips, hasAcknowledged, sourcePage) => {
    const payload = { shipment: shipmentKey, codingWips: codingWips, hasAcknowledged: hasAcknowledged };
    const url = `/receiving/scheduling/completed`;

    return post(url, payload, { passthrough: true });
};

export const getGS1ParentCategories = () => {
    const url = `/categories`;

    return get(url).then(mapCategoriesToSelect);
};

export const getGS1ChildrenCategories = (code) => {
    const url = `/categories/${code}/children`;

    return get(url).then(mapCategoriesToSelect);
};

export const getInhouseCategories = (term) => {
    const url = `/picklists/categories/?contains=${term}`;

    return get(url);
};

export const saveSkipSection = (wipKey, key, value) => {
    const attribute = {};
    attribute[key] = value;

    return patch(`/tasking/contexts/${wipKey}`, attribute);
};

export const patchTaskContext = (wipKey, key, value) => {
    const attribute = {};
    attribute[key] = value;

    return patch(`/tasking/contexts/${wipKey}`, attribute);
};

export const updateShipmentProperty = (shipmentProductKey, name, value) => {
    const payload = {
        [name]: value,
    };

    return patch(`/receiving/shipments/products/${shipmentProductKey}`, payload);
};

export const getShipment = (shipmentId) => {
    return get(`/receiving/shipments/${shipmentId}`);
};
